<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Proses GENERATE kiriman
        <div class="card-header-actions">
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-row style="margin-top:-10px;">
        <b-col lg="7">
          <b-row >
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 pr-2">Tanggal Kirim</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.tanggal"
                  for="tanggal"
                  type="date"
                  :state="!$v.model.tanggal.$error"
                  @change="gantiTanggal"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <button class="btn btn-success mr-1" @click.stop="generate()">
                <i class="fa fa-play"></i> Generate
              </button>
              <button class="btn btn-danger mr-1" @click.stop="generateCancel()">
                <i class="fa fa-trash"></i> Hapus Kiriman
              </button>
              <button class="btn btn-primary mr-1" @click.stop="showHistory=true">
                Show Process History
              </button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-card no-body v-if="showHistory==false">
        <b-tabs card >
            <b-tab title="Hasil Proses" active>
              <b-table
                class="mb-0"
                ref="tableHasil"
                outlined
                striped
                hover
                small
                style="font-size:smaller;"
                :items="data"
                :fields="tblData.tblFields"
                :current-page="tblData.page"
                :per-page="tblData.limit"
                show-empty
              >
              <template v-slot:cell(tanggal)="data">
                {{ data.item.tanggal | moment("DD MMM YYYY") }}
              </template>
              <!-- <template
                v-slot:cell(customer_group)="data"
              >{{data.item.customer_group==="KORANLANGGANAN"?"LANGGANAN":"AGEN"}}</template> -->
              <template v-slot:cell(DeliveryAddr)="data">
                <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; width:180px !important; font-size:smaller">
                {{ data.item.DeliveryAddr }}</div>
              </template>
                <template v-slot:cell(empty)="scope">
                  <h4>{{ scope.emptyText }}</h4>
                </template>
                <template v-slot:cell(emptyfiltered)="scope">
                  <h4>{{ scope.emptyFilteredText }}</h4>
                </template>
              </b-table>
              <b-row style="height: 25px !important;">
                <b-col cols="4">
                  <div>
                    Showing {{(tblData.page - 1) * tblData.limit + 1}}
                    to
                    <span
                      v-if="((tblData.page * tblData.limit)>tblData.total)"
                    >{{tblData.total}}</span>
                    <span v-else>{{tblData.page * tblData.limit}}</span>
                    of {{tblData.total}} entries
                  </div>
                </b-col>
                <b-col cols="4">
                    <b-input-group style="width: 200px;">
                      <b-input-group-prepend class="mb-0"><span class="p-2">Limit per page</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${tblData.limit} records`" style="max-width:80px; !important;"></b-form-input>  
                    </b-input-group>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    align="right"
                    :total-rows="tblData.total"
                    :per-page="tblData.limit"
                    v-model="tblData.page"
                    @click="refresh"
                  ></b-pagination>
                </b-col>
              </b-row>
            <b-row align-h="between" class="mt-3">
              <b-col lg="8" xl="6">
                <b-input-group>
                      <b-input-group-prepend><span class="input-group-text">TOTAL Berbayar</span></b-input-group-prepend>              
                      <b-form-input :value="tblData.totpaid | numFormat" readonly class="text-right font-weight-bold"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">Tdk.Berbayar</span></b-input-group-prepend>              
                      <b-form-input :value="tblData.totunpaid | numFormat" readonly class="text-right font-weight-bold mr-2"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">TOTAL OC</span></b-input-group-prepend>              
                      <b-form-input :value="tblData.totkirim | numFormat" readonly class="text-right font-weight-bold"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">Eksemplar</span></b-input-group-prepend>                 
                </b-input-group>
              </b-col>
              <b-col lg="4" xl="3">
              <b-input-group>
                  <b-input-group-prepend><span class="input-group-text">Nilai Berbayar</span></b-input-group-prepend>              
                  <b-form-input :value="tblData.kirtotal_val | numFormat('0,0.00')" readonly class="text-right font-weight-bold"></b-form-input>
                  <b-input-group-prepend><span class="input-group-text">{{uanguser}}</span></b-input-group-prepend>              
              </b-input-group>
            </b-col>
          </b-row>

            </b-tab>
            <b-tab title="Titipan bermasalah, Agen Libur/Tutup" >
              <b-table
                class="mb-0 my-table-scroll"
                ref="tblMasalah"
                outlined
                hover
                style="font-size:smaller;"
                :fields="titipanBermasalah.tblFields"
                :items="titipanBermasalah.items"
                :current-page="titipanBermasalah.page"
                :per-page="titipanBermasalah.limit"
                :sort-by.sync="titipanBermasalah.sortBy"
                :sort-desc.sync="titipanBermasalah.sortDesc"
                :key="titipanBermasalah.limit"
              >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(action)="data">
                  <div class="text-center">
                    <a href="javascript:void(0)" @click="edit(data.item)">
                      <i class="fa fa-pencil"></i>
                    </a>
                  </div>
                </template>

              </b-table>
              <b-row class="mt-2">
                <b-col cols="4">
                  <div>
                    Showing
                    {{(titipanBermasalah.page - 1) * titipanBermasalah.limit + 1}}
                    to
                    {{titipanBermasalah.page * titipanBermasalah.limit}}
                    of
                    {{titipanBermasalah.total}}
                    entries

                <button class="btn btn-primary ml-1" @click.stop="print(model)" :disabled="(titipanBermasalah.items.length==0)">
                <i class="fa fa-pencil-square-o"></i> Edit</button>

                  </div>
                </b-col>
                <b-col cols="4">
                  <b-form-group label-cols="3" label="Limit per page" class="mb-0">
                    <b-form-select
                      :options="[10, 20, 30, 50, 70, 90, 120]"
                      :plain="true"
                      v-model="titipanBermasalah.limit"
                      style="width:80px;"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    align="right"
                    :total-rows="titipanBermasalah.total"
                    :per-page="titipanBermasalah.limit"
                    v-model="titipanBermasalah.page"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-tab>
        </b-tabs>
      </b-card>
      <b-card v-else>
          <h5>History Proses</h5>
          <b-row >
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:90px !important;">Tgl. Proses</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmHistory.tgl1" type="date" placeholder="from date"></b-form-input>
                <b-input-group-append>
                  <span class="input-group-text">s.d.</span>
                </b-input-group-append>
                <b-form-input v-model="frmHistory.tgl2" type="date" placeholder="until date"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:90px !important;">Tgl. Edisi</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmHistory.tanggal" type="date" placeholder="Tgl.Edisi"></b-form-input>
                    <b-button class="btn btn-success ml-1"  @click="openHistory()">
                      <i class="fa fa-refresh"></i> Apply Filter
                    </b-button>
                    <b-button class="btn btn-secondary ml-1"   @click="clearFilterHistory()">
                      <i class="fa fa-eraser"></i> Clear Filter
                    </b-button>
              </b-input-group>
            </b-col>
          </b-row>
              <b-table
                class="mb-0 my-table-scroll"
                ref="tblHistory"
                outlined
                hover
                style="font-size:smaller;"
                :fields="frmHistory.tblFields"
                :items="dataHistory"
                :current-page="frmHistory.page"
                :per-page="frmHistory.limit"
                :sort-by.sync="frmHistory.sortBy"
                :sort-desc.sync="frmHistory.sortDesc"
                :key="frmHistory.limit"
              >
              <template v-slot:cell(tanggal)="data">
                {{ data.item.tanggal | moment("ddd, DD MMM YYYY") }}
              </template>
              <template v-slot:cell(modified)="data">
                {{ data.item.modified |  moment("ddd, DD-MMM-YYYY hh:mm:ss") }}
              </template>

              </b-table>
              <b-row class="mt-2">
                <b-col cols="4">
                  <div>
                    Showing
                    {{(frmHistory.page - 1) * frmHistory.limit + 1}}
                    to
                    {{frmHistory.page * frmHistory.limit}}
                    of
                    {{frmHistory.total}}
                    entries
                  </div>
                </b-col>
                <b-col cols="4">
                  <b-form-group label-cols="3" label="Limit per page" class="mb-0">
                    <b-form-select
                      :options="[10, 20, 30, 50, 70, 90, 120]"
                      :plain="true"
                      v-model="frmHistory.limit"
                      style="width:80px;"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    align="right"
                    :total-rows="frmHistory.total"
                    :per-page="frmHistory.limit"
                    v-model="frmHistory.page"
                  ></b-pagination>
                </b-col>
              </b-row>

              <button class="btn btn-primary mr-1" @click.stop="showHistory=false">
                Close History Proses
              </button>

      </b-card>
      <b-row class="justify-content-center">
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import moment from "moment";
import crud from "../../apis/crud";
import koran_kiriman from "../../apis/koran_kirim_pesanan";
import Loading from "vue-loading-overlay";

import { validationMixin } from "vuelidate";
import {required} from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      tanggal: { required }
    },
  },
  data() {
    return {
      showHistory:false,
      // tglaktif: moment().subtract(5,'days').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      canProses: true,
      horizontal: true,
      isLoading: false,
      model: {},
      tblData: {
        items:[],
        tblFields: [
            {
              key: "tanggal",
              label: "Tanggal Kiriman",
              thStyle: "width:90px",
              sortable: true
            },
            {
              key: "nofaktur",
              label: "No Faktur",
              thStyle: "width:100px",
              sortable: true
            },

            {
              key: "CustCode",
              label: "Kode",
              sortable: true
            },
            {
              key: "CustName",
              label: "Nama Agen",
              sortable: true
            },
            {
              key: "kiriman_name",
              label: "Jenis Kiriman",
              sortable: true
            },
            {
              key: "totpaid",
              label: "Kiriman Berbayar",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            {
              key: "gratis",
              label: "Kiriman Tdk.Berbayar",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            {
              key: "titipan",
              label: "Kiriman Titipan",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            {
              key: "totkirim",
              label: "Total Kiriman",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            {
              key: "DeliveryAddr",
              label: "Alamat Kirim",
              thStyle: "width:200px",
            },
            {
              key: "jurusan_name",
              label: "Jurusan",
              sortable: true
            },
            {
              key: "kota_name",
              label: "Kota Layanan",
              sortable: true
            },
        ],        
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tanggal",
        sortDesc: false
      },
      titipanBermasalah : {
        items:[],
        tblFields: [
          {
            key: "tanggal",
            label: "Tanggal Kiriman",
            thStyle: "width:160px",
            sortable: true
          },
          {
            key: "nofaktur",
            label: "No Faktur",
            thStyle: "width:160px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Nama Customer",
            sortable: true
          },
          {
            key: "DeliveryAddr",
            label: "Alamat Kirim",
          },
          {
            key: "totpaid",
            label: "Kiriman Berbayar",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "gratis",
            label: "Kiriman TdkBayar",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "totkirim",
            label: "Total Kiriman",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "namaAgentDititip",
            label: "Kiriman dititip ke AGEN",
            thClass: "text-center",
            tdClass: "text-center"
          },
        { key: "action", label: "Action", thStyle: "width:40px" },
        ],         
        page: 1,
        limit: 10,
        total: 0,
        sortBy: "CustName",
        sortDesc: false
      },
      frmHistory: {
        tablename:'koran-generate-history',
        tblFields: [
            {
              key: "tanggal",
              label: "Tanggal Kiriman",
              sortable: true
            },
            {
              key: "actionname",
              label: "Action/Proses ",
              sortable: true
            },
            {
              key: "actionby",
              label: "Action By",
              sortable: true
            },
            {
              key: "actionstatus",
              label: "Action Status",
            },
            {
              key: "modified",
              label: "Action Time",
              sortable: true
            },
        ],        
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tanggal",
        sortDesc: false
      },

    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidContact() {
      this.$v.contact.obj.$touch();
      return this.$v.contact.obj.$invalid;
    },
    maxIssuedDate() {
      return moment(new Date()).format("YYYY-MM-DD");
    }
  },
  created: async function() {
  //   if (this.$route.params.nofaktur) {
  //     this.canProses = false;
  //     toastr.info("Harap tunggu, sedang memuat infromasi.");
  //     try {
  //       this.tblData.nofaktur = this.$route.params.nofaktur;
  //       this.refresh();
  //       // this.$forceUpdate();
  //       toastr.clear;
  //     } catch (error) {
  //       console.log("error : ", error);
  //       toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
  //     }
  //   }
     this.frmHistory.tgl1=this.tglaktif;
  },
  methods: {
    data: async function(ctx) {
      if ((this.tblData.tgl1) && (this.tblData.tgl1))  {
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await koran_kiriman.list(this.tblData);
        list.forEach((el, idx) => {
          list[idx].tanggal = moment(el.tanggal).format("YYYY-MM-DD");
        });
        return list;
      } else {
        return [];
      } 
    },
    gantiTanggal(){
      this.tblData.tgl1='';
      this.refresh();
    },
    generateCancel: async function() {
      if (this.invalidModel) {
        const invalidobj={};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
             if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
          }
        }        
        console.log('validation model: ', this.$v.model);
        console.log('validation field: ', invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading=false;        
      } else if (moment(this.model.tanggal).format("YYYY-MM-DD")<this.tglaktif) {
              toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
              this.isLoading=false;        
      } else {
        this.tblData.tgl1 = null;
        this.tblData.tgl2 = null;
        toastr.info("Proses menghapus kiriman Koran. Harap tunggu");
        this.isLoading = true;
        try {
          let jawaban = true;
            const kirimanSrc = await koran_kiriman.cekkiriman({tanggal: moment(this.model.tanggal).format('YYYY-MM-DD')});
            // console.log(`Kiriman tanggal ${moment(this.model.tanggal).format('DD MMM YYYY')}: `,kirimanSrc);
            this.isLoading = false;
            if (kirimanSrc.totkirim){
                jawaban=false;
                  const pesan = `Data Kiriman tgl.${moment(this.model.tanggal).format('DD MMM YYYY')} ada dihapus:     
                                 \n Jml.Customer: ${kirimanSrc.totcustomer} TotalOplah: ${kirimanSrc.totkirim}eks.,                                 
                                 \n Apakah Anda yakin Hapus Kiriman dilanjutkan ?`
                  jawaban = await this.$bvModal.msgBoxConfirm(pesan, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
                if (jawaban== false ) {
                    return;
                } 
            }
            if (jawaban==true) {
                  this.tblData.tgl1 = this.model.tanggal;
                  this.tblData.tgl2 = this.model.tanggal;
                  const data = await koran_kiriman.generateCancel(this.model);
                  this.titipanBermasalah.items=data;
                  this.isLoading = false;
                  toastr.success("Hapus kiriman koran telah berhasil",'information',10000);
                  this.refresh();
                  this.$forceUpdate();
                  toastr.clear;
            }
        } catch (error) {
          this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
        }
      }
    },
    generate: async function() {
      if (this.invalidModel) {
        const invalidobj={};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
             if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
          }
        }        
        console.log('validation model: ', this.$v.model);
        console.log('validation field: ', invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading=false;        
      } else if (moment(this.model.tanggal).format("YYYY-MM-DD")<this.tglaktif) {
              toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
              this.isLoading=false;        
      } else {
        this.tblData.tgl1 = null;
        this.tblData.tgl2 = null;
        toastr.info("Proses pembuatan Kiriman Koran. Harap tunggu");
        this.isLoading = true;
        try {
          let jawaban = true;
            const kirimanSrc = await koran_kiriman.cekkiriman({tanggal: moment(this.model.tanggal).format('YYYY-MM-DD')});
            // console.log(`Kiriman tanggal ${moment(this.model.tanggal).format('DD MMM YYYY')}: `,kirimanSrc);
            this.isLoading = false;
            if (kirimanSrc.totkirim){
                jawaban=false;
                  const pesan = `Data Kiriman tgl.${moment(this.model.tanggal).format('DD MMM YYYY')} sudah ada:     
                                 \n Jml.Customer: ${kirimanSrc.totcustomer} TotalOplah: ${kirimanSrc.totkirim}eks.,                                 
                                 \n Apakah Anda yakin proses GENERATE dilanjutkan ?`
                  jawaban = await this.$bvModal.msgBoxConfirm(pesan, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
                if (jawaban== false ) {
                    return;
                } 
            }
            if (jawaban==true) {
                  this.isLoading=true;
                  this.tblData.tgl1 = this.model.tanggal;
                  this.tblData.tgl2 = this.model.tanggal;
                  const data = await koran_kiriman.generate(this.model);
                  this.titipanBermasalah.items=data;
                  this.isLoading = false;
                  toastr.success("GENERATE kiriman koran telah berhasil",'information',10000);
                  this.refresh();
                  this.$forceUpdate();
                  toastr.clear;
                  this.isLoading=false;
                if (this.titipanBermasalah.items.length>0) {
                      toastr.error(`Ada ${this.titipanBermasalah.items.length} kiriman titipan bermasalah, Agen yg dititipin libur/nonaktif`, "ERROR MESSAGE", 20000);
                  }
            }
        } catch (error) {
            this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          // if (error.code === 500) {
          //   this.tblData.tgl1 = this.model.tanggal;
          //   this.tblData.tgl2 = this.model.tanggal;
          //   this.refresh();
          //   this.$forceUpdate();
          // }
        }
      }
    },
    edit: function(data) {
      // console.log("data", data);
      if (data.tanggal) {
        router.push({
          name: "koran.kirimantitipanerror",
          params: { tanggal: moment(data.tanggal).format('YYYY-MM-DD') }
        });
      } else {
        toastr.warn("Silahkan pilih data yang ingin diubah!");
      }
    },
    refresh(ctx) {
      if (this.$refs.tableHasil) this.$refs.tableHasil.refresh();
    },
    openHistory() {
      if (this.$refs.tblHistory) this.$refs.tblHistory.refresh();
    },
    clearFilterHistory() {
      this.frmHistory.tgl1='';
      this.frmHistory.tgl2='';
      this.frmHistory.tanggal='';
    },
    dataHistory: async function() {
      if (this.showHistory==true) {
          this.frmHistory.sortDir = this.frmHistory.sortDesc ? "desc" : "asc";
          this.lkuLoading=true;
            let str ='';
          if (this.frmHistory.tanggal){
              // str += str ? '&' : '';
               str += `tanggal=${moment(this.frmHistory.tanggal).format('YYYY-MM-DD')}`;
          }
          
          if (this.frmHistory.tgl1){
              str += str ? '&' : '';
              str += `modified=>=$`+moment(this.frmHistory.tgl1).format('YYYY-MM-DD');
            if (this.frmHistory.tgl2) {
              str = str + `&modified=<=$`+moment(this.frmHistory.tgl2).format('YYYY-MM-DD');
            } else {
              str = str + `&modified=<$`+moment(this.frmHistory.tgl1).add(1,'day').format('YYYY-MM-DD');
            }
          }
          this.frmHistory.customQuery=str;
          console.log('this.frmHistory.customQuery: ', this.frmHistory.customQuery);
          const list = await crud.list(this.frmHistory);     
          this.lkuLoading=false;
          return list;
      }
    },

    close() {
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ path: "home" });
      }
    }
  }
};
</script>